"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueByFilterType = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _react = _interopRequireDefault(require("react"));
var _tableContext = require("./Context/tableContext");
var _Table = _interopRequireDefault(require("./Components/emre-test/Table"));
var _EmptyView = _interopRequireDefault(require("./Components/EmptyView"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["style", "className", "showHeader", "locale", "emptyText", "zebra", "onRow", "onRowClick", "onRowDoubleClick", "locale", "expandable", "rowKey", "loading", "columns", "prefixCls", "rowSelection"]; // context
// components
// styles
// import './Styled/index.css';

var getValueByFilterType = exports.getValueByFilterType = function getValueByFilterType(filteredValue) {
  var _filteredValue = (0, _toArray2.default)(filteredValue),
    filterType = _filteredValue[0],
    props = _filteredValue[1],
    columnDef = _filteredValue[2],
    values = _filteredValue.slice(3);
  var firstFilter = values[0];
  var defaultValue = values;
  var filters = {
    ibanSearchFilter: firstFilter,
    dateFilter: firstFilter[0],
    timeFilter: {
      start: defaultValue[0],
      end: defaultValue[1]
    },
    numberFilter: {
      min: defaultValue[0],
      max: defaultValue[1]
    },
    currencyFilter: {
      min: defaultValue[0],
      max: defaultValue[1]
    },
    searchableFilter: firstFilter
  };
  return filters[filterType];
};
var Table = function Table(props) {
  var style = props.style,
    className = props.className,
    showHeader = props.showHeader,
    locale = props.locale,
    emptyText = props.emptyText,
    zebra = props.zebra,
    onRow = props.onRow,
    onRowClick = props.onRowClick,
    onRowDoubleClick = props.onRowDoubleClick,
    mergedLocale = props.locale,
    expandable = props.expandable,
    rowKey = props.rowKey,
    loading = props.loading,
    columns = props.columns,
    prefixCls = props.prefixCls,
    rowSelection = props.rowSelection,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isCellMode = props.mode === 'cell';
  var tableClassName = isCellMode ? 'editable-cell ' + className : 'editable-row' + className;
  var classString = (0, _classnames.default)(tableClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(props.size), true), "bordered", props.bordered), "zebra", props.expandedRowRender ? false : zebra));

  // tanstack tarafında kullanılan filterı, eski durumdaki dataya benzer şekilde cevirmek için kullanılır.
  var prepareFilters = function prepareFilters(filters) {
    // gelen filter
    return Object.keys(filters).reduce(function (acc, item, index) {
      var filter = filters[item];
      acc[filter.id] = getValueByFilterType(filter.value);
      return acc;
    }, {});
  };

  // Tanstack taraflı n.production hatası alaması adına colon verisi gelmeden ekrana çizilmemesi için
  // if (isNullOrUndefined(tableColumns)) return null;

  return /*#__PURE__*/_react.default.createElement(_Table.default, (0, _extends2.default)({}, restProps, {
    locale: locale,
    prefixCls: prefixCls,
    className: classString,
    emptyText: emptyText || /*#__PURE__*/_react.default.createElement(_EmptyView.default, {
      text: locale.emptyText || ''
    }),
    columns: props.columns,
    defaultSorting: _tableContext.eventHub.getState('sortOrder'),
    defaultWrapperClass: "".concat(props.mode === 'cell' ? 'editable-cell' : ''),
    rowSelection: rowSelection,
    expandable: expandable
  }));
};
var _default = exports.default = Table;